import React from "react";
import { MdStars } from "react-icons/md";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(MdStars).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const UpgradeIcon = (props) => {
  return <StyledIcon {...props} />;
};

UpgradeIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default UpgradeIcon;
